import React from "react";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import { useSelector } from "react-redux";

const InputGradientType = ({ value, onChange }) => {
  const { lang } = useSelector((state) => ({
    lang: state.changeLang.language.stepThree.gradient,
  }));

  return (
    <FloatingLabel label={lang[3]}>
      <Form.Select value={value} onChange={(e) => onChange(e.target.value)}>
        {Object.entries({ linear: lang[5], radial: lang[6] }).map(
          ([key, value]) => (
            <option key={key} value={key}>
              {value}
            </option>
          )
        )}
      </Form.Select>
    </FloatingLabel>
  );
};

export default InputGradientType;
